import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';



export interface DialogData {
  title: string;
  message: string;
  button1Text: string;
  button2Text: string;
  submitMethodType: number;
  dialogType: number;
  position: any;
  dialogPosData: any;
  progressPercentage: number;
}


@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {
  title!: string;
  message!: string;
  button1Text!: string;
  button2Text!: string;
  submitMethodType!: number;
  dialogType!: number;
  position: any;
  dialogPosData: any;
  uploadError = false;
  progressPercentage = 0;
  isSubmittingVideoResponse = false;
  // private readonly triggerElementRef: ElementRef;

  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) {
   }

  ngOnInit(): void {
    this.title = this.data.title;
    this.message = this.data.message;
    this.button1Text = this.data.button1Text;
    this.button2Text = this.data.button2Text;
    this.submitMethodType = this.data.submitMethodType;
    this.dialogType = this.data.dialogType;
    this.dialogPosData = this.data.dialogPosData;
  }

  onSubmitClick(): void {
    this.dialogRef.close({ isSubmit: true, SubmitMethodType: this.submitMethodType, DialogType: this.dialogType });
  }

  onCancelClick(): void {
    this.dialogRef.close({ isSubmit: false});
  }

  onSafariUpgradeClick(): void {
    this.dialogRef.close();
  }

}
